
import axios from 'axios'
import { Toast } from 'antd-mobile'

// 拦截请求

axios.interceptors.request.use(function(config){
	
	if(window.location.href.indexOf('game-detail')>0){

	}else{
		Toast.loading('加载中',0)
	}
	
	return config
})

// 拦截相应

axios.interceptors.response.use(function(config){
	
	Toast.hide()

	return config
})



// WEBPACK FOOTER //
// ./src/config.js